import { useEffect, useRef, useState } from 'react';
import './style.scss';
import { toHankaku } from 'views/utils/format/FormatString';

type LoginAccountProps = {
  branch: string;
  branchOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  account: string;
  accountOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  nextFormRef?: React.RefObject<HTMLInputElement>;
};

export const LoginAccount = (props: LoginAccountProps) => {
  const branchRef = useRef<HTMLInputElement>(null);
  const accountRef = useRef<HTMLInputElement>(null);
  const [isComposition, setComposition] = useState<boolean>(false);

  useEffect(() => {
    branchRef.current?.focus();
  }, []);

  useEffect(() => {
    if (props.branch.length >= 3 && !isComposition) accountRef.current?.focus();
  }, [props.branch, isComposition]);

  useEffect(() => {
    if (props.branch.length >= 3 && props.account.length >= 7 && !isComposition) props.nextFormRef?.current?.focus();
  }, [props.account, props.nextFormRef, isComposition, props.branch.length]);

  return (
    <div className="loginAccount">
      <AccountForm
        name="branch"
        label="口座番号(3桁)"
        maxLength={3}
        value={props.branch}
        onChange={props.branchOnChange}
        setCompisition={setComposition}
        innerRef={branchRef}
      />
      <div className="loginAccount_field_hyphen">
        <div className="loginAccount_nolabel"></div>
        <div className="loginAccount_label_hyphen">-</div>
      </div>
      <AccountForm
        name="account"
        label="口座番号(7桁)"
        maxLength={7}
        value={props.account}
        onChange={props.accountOnChange}
        setCompisition={setComposition}
        innerRef={accountRef}
      />
    </div>
  );
};

type AccountProps = {
  name: string;
  label: string;
  value: string;
  maxLength: number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setCompisition: React.Dispatch<React.SetStateAction<boolean>>;
  innerRef?: React.RefObject<HTMLInputElement>;
};

const AccountForm = (props: AccountProps) => {
  const { name, label, value, maxLength, onChange, setCompisition, innerRef } = props;

  return (
    <div className={`loginAccount_field_${name}`}>
      <span className="loginAccount_label">{label}</span>
      <input
        className="loginAccount_field"
        name={name}
        value={value}
        maxLength={maxLength}
        onCompositionStart={() => setCompisition(true)}
        onCompositionEnd={(e) => {
          setCompisition(false);
        }}
        onChange={onChange}
        onBlur={(e) => {
          const val = toHankaku(e.target.value);
          e.target.value = val;
          onChange(e);
        }}
        ref={innerRef}
        inputMode="numeric"
      />
    </div>
  );
};
